/**
 * La sesión de una pantalla abierta embebida en otro producto (Unity 360).
 *
 * POR QUE NO SE GUARDA EN `localStorage`, QUE ERA LO OBVIO. Finance guarda su
 * sesión en `localStorage` bajo `token` / `tenantSlug` / `emisorId`, y el store
 * de zustand persiste en `auth-storage`. El iframe corre en el MISMO origen que
 * la aplicación normal, así que escribir ahí **le cambiaría la sesión al usuario
 * en sus otras pestañas**: quien tuviera Finance abierto aparte se encontraría
 * de pronto con un token de 8 horas y una sola empresa visible, sin haber hecho
 * nada. Y al cerrar el iframe se quedaría con eso puesto.
 *
 * Por eso la sesión embebida vive **solo en memoria**, en este módulo. Dura lo
 * que dura la pestaña, no se comparte con nada y al cerrar no deja rastro. El
 * interceptor de `api.js` la prefiere cuando está puesta.
 *
 * La otra mitad del mismo problema está en el interceptor de respuesta: ante un
 * 401 borraba todo y mandaba a `/login`. Adentro de un iframe eso es exactamente
 * el defecto que el plan prohíbe —pintar un segundo login dentro de la pantalla—
 * y además borraría la sesión buena del usuario. Embebido, un 401 se le avisa al
 * anfitrión y él resuelve.
 */

let sesion = null;

/** Quien manda los avisos al anfitrión. Lo pone la cáscara del embebido. */
let avisarAlAnfitrion = null;

export function ponerSesionEmbebida({ token, tenantSlug, emisorId }) {
  sesion = { token, tenantSlug, emisorId: emisorId != null ? String(emisorId) : null };
}

export function sesionEmbebida() {
  return sesion;
}

export function estaEmbebido() {
  return sesion !== null;
}

export function borrarSesionEmbebida() {
  sesion = null;
}

/** La cáscara registra acá cómo avisarle al anfitrión que la sesión venció. */
export function registrarAvisoDeSesion(fn) {
  avisarAlAnfitrion = typeof fn === 'function' ? fn : null;
}

/**
 * El interceptor de respuesta llama esto ante un 401. Devuelve `true` si el
 * aviso se dio y por lo tanto NO hay que redirigir a `/login`.
 */
export function avisarSesionVencida() {
  if (!sesion || !avisarAlAnfitrion) return false;
  // La sesión se borra: lo que venga después no debe reusar un token muerto.
  sesion = null;
  avisarAlAnfitrion();
  return true;
}
